module.exports = __webpack_public_path__ + "static/img/Front Eureka_8.70084047.png";